/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, Heading, HFlow, Icon, InfoLabel } from 'bold-ui'
import { ExamesDiabeteConsolidado } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'
import { formatDate } from 'util/date/formatDate'

interface AcompanhamentoCondicaoSaudeExamesAccordionPanelProps {
  exames: ExamesDiabeteConsolidado
}

export function AcompanhamentoCondicaoSaudeExamesAccordionPanel(
  props: AcompanhamentoCondicaoSaudeExamesAccordionPanelProps
) {
  const { exames } = props

  const hasHemoglobinaGlicada =
    !isUndefinedOrNull(exames?.hemoglobinaGlicada?.valor) &&
    !isUndefinedOrNull(exames?.hemoglobinaGlicada?.dataRealizacao)

  return (
    <Grid gap={0} alignItems='baseline' style={styles.content}>
      <Cell size={12} style={styles.item}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon icon='fileWithItemsFilled' size={1} />
          <Heading level={4}>Exames</Heading>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Hemoglobina glicada' placeholder='-' titleStyles={styles.title}>
          {hasHemoglobinaGlicada &&
            `${exames.hemoglobinaGlicada.valor.replace('.', ',')}% em ${formatDate(
              exames.hemoglobinaGlicada.dataRealizacao
            )}`}
        </InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Avaliação dos pés' placeholder='-' titleStyles={styles.title}>
          {formatDate(exames?.dataAvaliacaoPes)}
        </InfoLabel>
      </Cell>
    </Grid>
  )
}

const styles = {
  content: css`
    margin: 0;
    padding-top: 0.25rem;
  `,
  item: css`
    padding: 0.5rem 0 0;
  `,
  title: css`
    padding-bottom: 0.25rem;
  `,
}
